import { useState } from 'react';

import { data } from './data/data_01_epilogi'
// import kuva from './images/epilogi.jpg'
import kuva from './images/Pentti_neutral_300x430.png'
import Button from 'react-bootstrap/Button';
const Scene_01_epilogi = ({ visibilityHandler }) => {
    //otetaan vastaan propseista funktiot




    const jatka = () => {

        visibilityHandler("jatka sceneen 02")

    }



    return (


        <div className='sceneContainer'>

            <div id='image' className='kuvaBox'>
                <img className='sameSizeImg' src={kuva} alt='kuva' />
            </div>

            <div id='teksti'>
                <h4>{(data.teksti != null && data.teksti != "") ? data.teksti : null}</h4>
            </div>

            <div id='actions'>
                <Button onClick={() => jatka()}>jatka</Button>
            </div>
        </div>

    )

}

export default Scene_01_epilogi